import { render, staticRenderFns } from "./RelatorioRecebimentoPaciente.vue?vue&type=template&id=7472675a&scoped=true"
import script from "./RelatorioRecebimentoPaciente.vue?vue&type=script&lang=ts"
export * from "./RelatorioRecebimentoPaciente.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioRecebimentoPaciente.vue?vue&type=style&index=0&id=7472675a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472675a",
  null
  
)

export default component.exports